module.exports = __webpack_public_path__ + "static/img/manual-16.f0ea7c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-16.png
// module id = TIhC
// module chunks = 4